import { InjectedConnector } from "@web3-react/injected-connector"
import { TorusConnector } from "@web3-react/torus-connector"
import { WalletConnectConnector } from "@web3-react/walletconnect-connector"
import { WalletLinkConnector } from "@web3-react/walletlink-connector"

import { ChainId } from "../../constant/network"
import { IS_PROD } from "../../util/stage"

export const injected = new InjectedConnector({
    // NOTE: we handle supported ChainIds by ourself so don't need to this configurations
    // supportedChainIds: [ChainId.ARBITRUM_TESTNET_RINKEBY],
})

export const walletConnect = new WalletConnectConnector({
    rpc: {
        // NOTE: WalletConnect only requires https json rpc instead of wss rpc so hardcode https rpc url here.
        [ChainId.OPTIMISTIC_ETHEREUM]: "https://mainnet.optimism.io",
        [ChainId.OPTIMISTIC_ETHEREUM_TESTNET_KOVAN]: "https://kovan.optimism.io",
    },
    pollingInterval: 15000,
})

// NOTE: Use mainnet for default value
export const walletLinkConnect = new WalletLinkConnector({
    url: IS_PROD ? "https://mainnet.optimism.io" : "https://kovan.optimism.io",
    appName: "perp-exchange",
})

export const torusConnect = new TorusConnector({
    chainId: IS_PROD ? ChainId.OPTIMISTIC_ETHEREUM : ChainId.OPTIMISTIC_ETHEREUM_TESTNET_KOVAN,
    initOptions: {
        network: {
            host: IS_PROD ? "https://mainnet.optimism.io" : "https://kovan.optimism.io",
            chainId: IS_PROD ? ChainId.OPTIMISTIC_ETHEREUM : ChainId.OPTIMISTIC_ETHEREUM_TESTNET_KOVAN,
        },
    },
})
